import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import { i18n } from '@/plugins/i18n';
import { axiosInstance } from '@/setup/axios/AxiosConfig';
import { languages } from '@/core/standard/constants';
var loadedLanguages = [navigator.language.split('-')[0]];
export var supportedLang = Object.keys(languages);

function setI18nLanguage(lang) {
  var _a;

  localStorage.setItem('lang', lang);
  i18n.locale = lang;
  axiosInstance.defaults.headers.common['Accept-Language'] = lang;
  (_a = document.querySelector('html')) === null || _a === void 0 ? void 0 : _a.setAttribute('lang', lang);
  return lang;
}

export function loadLanguageAsync(lang) {
  if (!supportedLang.includes(lang)) {
    return Promise.reject('Language not supported.');
  } else {
    if (i18n.locale !== lang && loadedLanguages.includes(lang)) {
      return Promise.resolve(setI18nLanguage(lang));
    } else {
      return import(
      /* webpackChunkName: "lang-[request]" */
      "@/assets/locales/" + lang + ".ts").then(function (messages) {
        i18n.setLocaleMessage(lang, messages.default);
        loadedLanguages.push(lang);
        return setI18nLanguage(lang);
      }).catch(function () {
        setI18nLanguage('es');
        return Promise.reject('Language not supported.');
      });
    }
  }
}